export default class ErrorMessage {
	public code: number;
	public systemMessage: string;
	public message: string;

	public constructor(code: number, systemMessage: string, message: string) {
		this.code = code;
		this.systemMessage = systemMessage;
		this.message = message;
	}

	public formatErrorSystemMessage = (): string => {
		return `${this.code} - ${this.systemMessage}`;
	}

	// Checks to see if a generic object is a instance of class ErrorMessage.
	public static isErrorMessage(objToCheck: any): objToCheck is ErrorMessage {
		return (objToCheck as ErrorMessage).formatErrorSystemMessage !== undefined;
	}
}